export type LeftPanleActiveTab = {
  leftPanleActiveTab: string;
  leftPanleActiveTabStateName: string;
};

export const leftPanleActiveTabInitialState: LeftPanleActiveTab =
  {
    leftPanleActiveTab: "Permanent",
    leftPanleActiveTabStateName: "0",
  };
